var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37751 34.0013L4.57001 2.5H35.43L32.6188 33.9963L19.9813 37.5L7.37751 34.0013Z",
    fill: "#1572B6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 34.8224L30.2125 31.9912L32.615 5.07617H20V34.8224Z",
    fill: "#33A9DC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 16.4887H25.1125L25.465 12.5325H20V8.6687H29.6875L29.595 9.70495L28.6462 20.3525H20V16.4887Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0237 26.5224L20.0062 26.5274L15.7037 25.3649L15.4287 22.2837H11.55L12.0912 28.3499L20.005 30.5474L20.0237 30.5424V26.5224Z",
    fill: "#EBEBEB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7838 20.1887L24.3188 25.3625L20.01 26.525V30.545L27.93 28.35L27.9888 27.6975L28.66 20.1887H24.7838Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0138 8.6687V12.5325H10.6813L10.6038 11.6637L10.4275 9.70495L10.335 8.6687H20.0138ZM20 16.4887V20.3525H15.7513L15.6738 19.4837L15.4988 17.525L15.4063 16.4887H20Z",
    fill: "#EBEBEB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss);
export default __webpack_public_path__ + "static/media/css.b3d6dbf3f33fb310437f9f2a071108d4.svg";
export { ForwardRef as ReactComponent };